/**
 * React Query hooks for challenges
 */

import { useQuery } from '@tanstack/react-query';
import { api } from '@lib/api';
import { useAuth } from '@lib/auth';
import type { ChallengesResponse } from '@lib/types';

// Query keys
export const challengeKeys = {
  all: ['challenges'] as const,
  list: () => [...challengeKeys.all, 'list'] as const,
  history: () => [...challengeKeys.all, 'history'] as const,
};

// Fetch active challenges with user progress
export function useChallenges() {
  const { isAuthenticated, isLoading } = useAuth();
  
  return useQuery({
    queryKey: challengeKeys.list(),
    queryFn: () => api.get<ChallengesResponse>('/api/challenges'),
    staleTime: 1000 * 60, // 1 minute
    refetchInterval: 1000 * 60 * 2, // Refetch every 2 minutes
    enabled: isAuthenticated && !isLoading, // Only fetch when authenticated
  });
}

// Fetch completed challenges history
export function useChallengeHistory() {
  const { isAuthenticated, isLoading } = useAuth();
  
  return useQuery({
    queryKey: challengeKeys.history(),
    queryFn: () => api.get<ChallengesResponse>('/api/challenges/history'),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: isAuthenticated && !isLoading, // Only fetch when authenticated
  });
}
